// import ModalForm from "./Form";
import LeadListForm from "./LeadListForm";
import { LEAD, CITY, DATATABLE_EXPORT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const Schema = {
	components: { LeadListForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: LEAD + "?sub_status_id_operator=!=&sub_status_id=13",
			tableId: "lead-list-table",
			formId: "lead-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "CLC ID No",
					type: "custom-html",
					key: "clc_id_number",
					modifier: (value, row) => {
						return row.lead_id_number || row.clc_id_number || "-";
					},
				},
				{
					title: "Inquiry Date",
					type: "custom-html",
					key: "created_at",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: "Time To Contact",
					type: "custom-html",
					key: "call_times",
					modifier: (value) => {
						if (value) {
							return `<span class="badge badge-sm badge-pill badge-primary">${value}</span>`;
						} else {
							return `<span class="badge badge-sm badge-pill badge-primary">-</span>`;
						}
					},
				},
				{
					title: "Full Name",
					type: "text",
					key: "full_name",
				},
				{
					title: "D.O.B",
					type: "custom-html",
					key: "date_of_birth",
					modifier: (value) => {
						if (value) {
							const date = new Date(value);
							const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

							const day = date.getDate().toString().padStart(2, "0");
							const month = months[date.getMonth()];
							const year = date.getFullYear();

							return `${day}-${month}-${year}`;
						}
					},
				},
				{
					title: "School Name",
					type: "custom-html",
					key: "school",
					modifier: (value,row) => {
						if (!value) return "-";

						if (value.name === "Others") {
							return `Others (${row.school_name_other ?? "-"})`;
						}

						return value.name ?? "-";
					},
				},
				{
					title: "School Level",
					type: "custom-html",
					key: "school_level",
					modifier: (value) => {
						return value?.name ?? "-";
					},
				},
				{
					title: "Center",
					type: "custom-html",
					key: "center",
					modifier: (value) => {
						return value?.name ?? "-";
					},
				},
				{
					title: "Learning Program",
					type: "custom-html",
					isVisible: true,
					key: "learning_interests",
					modifier: (value) => {
						return value?.name ?? "-";
					},
				},
				// {
				// 	title: "Sub Status",
				// 	type: "custom-html",
				// 	key: "sub_status",
				// 	isVisible: true,
				// 	modifier: (value) => {
				// 		if (value && value.status) {
				// 			return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
				// 				value.status
				// 			)}</span>`;
				// 		}
				// 	},
				// },
				{
					title: "Area of Residency",
					type: "custom-html",
					key: "area_of_residency",
					isVisible: true,
					modifier: (value) => {
						if (value && value.name) {
							return `<span>${this.$t(value.name)}</span>`;
						}
					},
				},
				{
					title: "Interview Date",
					type: "custom-html",
					key: "parent_interview_date_time",
					modifier: (value) => {
						if (!value) return "-";

						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "LeadListTable",
				url: LEAD + "?sub_status_id_operator=!=&sub_status_id=13",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				rowClass: (rowData) => {
					let classes = [];

					if (rowData.parent_interview_status != 1) {
						
						if(rowData.valid_status == null ){
							classes.push('fn-green-row');
						}else if(rowData.valid_status == 2){
							classes.push( 'fn-red-row');
						}

					}else{
						classes.push('bg-green-row');
						if (rowData.valid_status == 2) {
							classes.push( 'fn-red-row');
						}
					}

					return classes.join(' ');
				},
				actions: [
					// {
					// 	title: this.$t("edit"),
					// 	icon: "edit",
					// 	type: "none",
					// 	component: "app-add-modal",
					// 	// component: "lead-list-form",
					// 	modalId: "lead-list-form",
					// 	modifier: () => this.$can('view_list_lead_button_modalupdateinfo')
					// },
					// {
					// 	title: "Parent Interview Form",
					// 	icon: "clipboard",
					// 	type: "page", // or "page" if you want to navigate to a new page
					// 	url: "/transaction/parent-interview", // Specify the URL you want to navigate to
					// 	target: "", // "_blank" if you want to open the URL in a new tab
					// 	uniqueKey: (rowData) => rowData.id,
					// 	disabled: (rowData) => this.isPifDisabled(rowData),
					// 	modifier: () => this.$can('view_list_lead_button_piv')
					// },
					{
						title: "Lead Profile",
						icon: "user", // You can use an appropriate icon here
						type: "page", // or "page" if you want to navigate to a new page
						url: "/transaction/profile-lead", // Specify the URL you want to navigate to
						target: "", // "_blank" if you want to open the URL in a new tab
						uniqueKey: (rowData) => rowData.id,
						modifier: () => this.$can('view_list_lead_button_leadprofile')
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
					{
						title: "Year Of Birth",
						type: "search-and-select-filter",
						key: "year_of_birth",
						settings: {
							url: `/transaction/lead/getListYear`, 
							modifire: (v) => {
								return { id: v.id, name: v.name };
							},
							per_page: 10, 
							queryName: "search",
							loader: "app-pre-loader",
							multiple: false,
							params: {
								is_active: true,
							}, 
						},
						listValueField: "name",
					},
					{
						title: "Center",
						type: "search-and-select-filter",
						key: "center_id",
						settings: {
							url: `/master/center`, 
							modifire: (v) => {
								return { id: v.id, name: v.name };
							},
							per_page: 10, 
							queryName: "search",
							loader: "app-pre-loader",
							multiple: false,
							params: {
								is_active: true,
							}, 
						},
						listValueField: "name",
					},
					{
						title: "School Level",
						type: "search-and-select-filter",
						key: "school_level_id",
						settings: {
							url: `/master/school-level`, 
							modifire: (v) => {
								return { id: v.id, name: v.name };
							},
							per_page: 10, 
							queryName: "search",
							loader: "app-pre-loader",
							multiple: false,
							params: {
								is_active: true,
							}, 
						},
						listValueField: "name",
					},
					// {
					// 	title: this.$t("age"),
					// 	type: "range-filter",
					// 	key: "age",
					// 	maxTitle: this.$t("max_age"),
					// 	minTitle: this.$t("min_age"),
					// 	sign: "",
					// },
					// {
					// 	title: "Learning Program",
					// 	type: "checkbox",
					// 	key: "learning_interests",
					// 	option: [
					// 		{ id: "online_learning", value: "Online Learning" },
					// 		{
					// 			id: "on_site_learning",
					// 			value: "On-site learning",
					// 		},
					// 		{ id: "hybrid_learning", value: "Hybrid Learning" },
					// 		{ id: "clc_study_club", value: "CLC Study Club" },
					// 		{ id: "clc_apps", value: "CLC Apps" },
					// 		{ id: "other", value: "Other" },
					// 	],
					// },
					// {
					// 	title: "Sub Status",
					// 	type: "radio",
					// 	key: "sub_status.status",
					// 	option: [
					// 		{ id: "male", value: "Male" },
					// 		{ id: "female", value: "Female" },
					// 		{ id: "other", value: "Other" },
					// 	],
					// 	header: {
					// 		title: this.$t("want_to_filter_your_list"),
					// 		description: this.$t(
					// 			"you_can_filter_your_data_table_which_are_created_based_on_gender"
					// 		),
					// 	},
					// },
					// {
					// 	title: "Area of Residency",
					// 	type: "search-and-select-filter",
					// 	key: "city_id",
					// 	settings: {
					// 		url: `/${CITY}`, // this url will hit every search action
					// 		modifire: (v) => {
					// 			return { id: v.id, name: v.name };
					// 		},
					// 		per_page: 10, // default 10, you can change it any number. min 10 encourage to use
					// 		queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
					// 		loader: "app-pre-loader", // default app-overlay-loder
					// 		multiple: true, // default false, if you need to select multiple item so make it true
					// 		params: {
					// 			is_active: true,
					// 		}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
					// 	},
					// 	listValueField: "name",
					// },
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isPifDisabled(rowData) {
			if (rowData.status === "inactive") return true;
			else if (rowData.status === "not_interested") return true;
			else if (rowData.status === "invalid") return true;
			else return false;
		},
	},
};
